import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isNavActive, setIsNavActive] = useState(false);
  const location = useLocation();

  const toggleNav = () => {
    setIsNavActive(!isNavActive);
  };

  const closeNav = () => {
    setIsNavActive(false);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'nav-link active' : 'nav-link';
  };

  return (
    <header>
      <div className="container">
        <div className="header-inner">
          <Link to="/" className="logo" onClick={closeNav}>
            <img src="/logos/Trimline Group Logo.png" alt="Trimline Group" />
          </Link>
          <div className={`mobile-toggle ${isNavActive ? 'active' : ''}`} onClick={toggleNav}>
            <i className={`fas ${isNavActive ? 'fa-times' : 'fa-bars'}`}></i>
          </div>
          <nav className={isNavActive ? 'active' : ''}>
            <ul>
              <li><Link to="/" className={isActive('/')} onClick={closeNav}>Home</Link></li>
              <li><Link to="/about" className={isActive('/about')} onClick={closeNav}>About Us</Link></li>
              <li><Link to="/subsidiaries" className={isActive('/subsidiaries')} onClick={closeNav}>Subsidiaries</Link></li>
              <li><Link to="/trade" className={isActive('/trade')} onClick={closeNav}>International Trade</Link></li>
              <li><Link to="/brands" className={isActive('/brands')} onClick={closeNav}>E-Commerce & Brands</Link></li>
              <li><Link to="/tech" className={isActive('/tech')} onClick={closeNav}>Tech</Link></li>
              <li><Link to="/contact" className={isActive('/contact')} onClick={closeNav}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;